var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScrollLockimg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 147.96 147.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff2c10;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #70240f;\n      }\n\n      .cls-3 {\n        fill: #f46047;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 23.09,
    y: 23.1,
    width: 100.96,
    height: 100.96
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 142.34,
    cy: 54.68,
    rx: 5.62,
    ry: 5.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.14,41.17V0H0v147.16h147.14v-78.98h-9.95v69.03H9.95V9.95h127.24v31.22h9.95Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 37.14,
    cy: 111.79,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 110,
    cy: 111.79,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 61.43,
    cy: 85.81,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 61.43,
    cy: 59.83,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 37.14,
    cy: 33.85,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 85.71,
    cy: 85.81,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 85.71,
    cy: 59.83,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 110,
    cy: 33.85,
    rx: 5.59,
    ry: 5.24
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollLockimg);
export default __webpack_public_path__ + "static/media/scroll-lockimg.edd040679f09a57a631c8597205c0d74.svg";
export { ForwardRef as ReactComponent };